import React from 'react';
import Footer from '../components/Footer';

export default function PoliticaConfidentialitate() {
  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="legal-page">
          <div className="legal-box">
            <h1>🔒 Politica de confidențialitate</h1>
            <div className="legal-updated">Ultima actualizare: 2026 — Monitorizare Flotă, o marcă a SoftConsult</div>

            <p>
              Această politică de confidențialitate explică ce date colectăm prin aplicația
              „Monitorizare Flotă" (denumită în continuare „Aplicația"), în ce scop le folosim,
              cum le protejăm și care sunt drepturile dumneavoastră, în calitate de utilizator
              sau reprezentant al firmei client.
            </p>

            <h2>1. Cine suntem</h2>
            <p>
              Aplicația este operată de SoftConsult, în calitate de furnizor al platformei de
              gestiune a parcului auto. Prin crearea unui cont sau prin trimiterea unei cereri de
              înregistrare a unei firme noi, sunteți de acord cu prelucrarea datelor descrise mai jos.
            </p>

            <h2>2. Ce date colectăm</h2>
            <ul>
              <li>Date de identificare a firmei: denumire, CUI/CIF, adresă, persoană de contact, telefon, email;</li>
              <li>Date de cont: nume utilizator, parolă (stocată criptat), rol (utilizator/administrator);</li>
              <li>Date privind autovehiculele administrate: serie, tip, date tehnice, revizii, documente asociate;</li>
              <li>Date financiare operaționale: cheltuieli, alimentări carburant, facturi piese și service, introduse de utilizator;</li>
              <li>Date tehnice minime necesare funcționării: adresă IP, informații despre sesiune/browser, jurnale (log-uri) de acces și erori.</li>
            </ul>

            <h2>3. Scopul prelucrării</h2>
            <p>
              Datele sunt folosite exclusiv pentru: furnizarea funcționalităților Aplicației
              (evidența vehiculelor, cheltuielilor, reviziilor și alertelor de expirare),
              autentificarea și securitatea contului, comunicarea legată de contul dumneavoastră
              (confirmări, notificări, recuperare parolă) și îmbunătățirea tehnică a serviciului.
            </p>

            <h2>4. Stocare, securitate și backup</h2>
            <p>
              Datele sunt stocate pe servere securizate, iar accesul la ele este restricționat prin
              autentificare. Pentru protecția datelor, se efectuează în mod curent o copie de
              siguranță (backup) zilnică a bazei de date.
            </p>
            <div className="legal-highlight">
              ⚠️ Deși efectuăm backup zilnic, acesta reprezintă o măsură de precauție și nu o
              garanție absolută. SoftConsult nu își asumă răspunderea pentru pierderea, alterarea
              sau divulgarea datelor cauzate de atacuri cibernetice, acces neautorizat, incidente de
              securitate, defecțiuni externe sau evenimente care nu pot fi controlate în mod
              rezonabil de operator. Întreaga răspundere pentru consecințele unei astfel de pierderi
              de date revine utilizatorului/firmei client, inclusiv obligația de a-și păstra propriile
              copii ale documentelor și informațiilor esențiale, acolo unde este posibil.
            </div>

            <h2>5. Partajarea datelor</h2>
            <p>
              Nu vindem și nu închiriem datele dumneavoastră către terți. Datele pot fi partajate
              doar cu furnizori tehnici strict necesari funcționării Aplicației (de exemplu,
              găzduire server, transmitere email), care sunt obligați contractual să respecte
              confidențialitatea acestora, sau atunci când legea o impune (ex. solicitare din partea
              autorităților competente).
            </p>

            <h2>6. Perioada de stocare</h2>
            <p>
              Datele sunt păstrate pe durata existenței contului. La solicitarea de ștergere a
              contului sau la încetarea colaborării cu firma client, datele pot fi șterse sau
              anonimizate, cu excepția situațiilor în care legea impune o perioadă minimă de
              păstrare (de exemplu, evidențe financiar-contabile).
            </p>

            <h2>7. Drepturile dumneavoastră</h2>
            <p>
              Conform legislației aplicabile privind protecția datelor cu caracter personal, aveți
              dreptul de acces, rectificare, ștergere, restricționare a prelucrării, portabilitate a
              datelor și dreptul de a vă opune prelucrării, precum și dreptul de a depune o plângere
              la autoritatea de supraveghere competentă. Pentru exercitarea acestor drepturi, ne
              puteți contacta la datele de contact de mai jos.
            </p>

            <h2>8. Aplicația gratuită — limite de utilizare</h2>
            <p>
              Aplicația este oferită gratuit în limita unui singur utilizator și a unui singur
              autovehicul per firmă înregistrată. Detalii complete despre acest aspect se regăsesc
              în{' '}
              <a href="/termeni" target="_blank" rel="noopener noreferrer">Termenii și condițiile</a>
              {' '}Aplicației.
            </p>

            <h2>9. Modificări ale acestei politici</h2>
            <p>
              Această politică poate fi actualizată periodic. Orice modificare semnificativă va fi
              comunicată prin publicarea noii versiuni pe această pagină, împreună cu data ultimei
              actualizări.
            </p>

            <h2>10. Contact</h2>
            <p>
              Pentru întrebări legate de protecția datelor sau de prezenta politică, ne puteți
              contacta prin intermediul{' '}
              <a href="https://www.softconsult.ro" target="_blank" rel="noopener noreferrer">
                softconsult.ro
              </a>.
            </p>

            <a className="legal-back" href="/login">← Înapoi la pagina de conectare</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
